import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  currentYear = new Date().getFullYear();
  versionType: any;

  constructor(
    private authendicationService: AuthenticationService,
  ) { }

  ngOnInit(): void {
    this.getVersion();
  }

  getVersion(){
    this.authendicationService.getVersion().subscribe(result => {
      if (result && result.response == '200') {
        this.versionType = result.data;
      }
    });
  }

}
